module.exports = __webpack_public_path__ + "static/Gatsby-df104ee4e3c8def477dffe0d8287d675.png";